import React from "react";
import MaInput from "../../../../Components/UI/ma-input";
import { InputAdornment, MenuItem, Tab, Tabs } from "@mui/material";
import { LuSearch } from "react-icons/lu";
import { PRODUCT_FILTER_MENU_PROPS } from "../products/product-filter-menu-styles";

const TABS = [
  { key: "all", label: "All" },
  { key: "pending", label: "Pending" },
  { key: "approved", label: "Approved" },
  { key: "rejected", label: "Rejected" },
];

const FILTER_SELECT_PROPS = {
  MenuProps: PRODUCT_FILTER_MENU_PROPS,
};

const tabSx = {
  borderBottom: "1px solid #ECECEC",
  minHeight: 44,
  "& .MuiTabs-flexContainer": { gap: 0 },
  "& .MuiTabs-indicator": {
    backgroundColor: "#18181B",
    height: 2,
    borderRadius: "999px",
  },
  "& .MuiTab-root": {
    textTransform: "none",
    fontSize: "13px",
    fontWeight: 600,
    minHeight: 44,
    py: 1,
    px: 1.5,
    minWidth: "auto",
    color: "#9CA3AF",
    "&:hover": { color: "#6B7280" },
    "&.Mui-selected": { color: "#18181B" },
  },
};

export function ApprovalFilterBar({
  activeTab,
  onTabChange,
  search,
  onSearchChange,
  statusMenu,
  onStatusMenuChange,
  categoryMenu,
  onCategoryMenuChange,
  statusMenuDisabled,
}) {
  return (
    <div className="space-y-4 md:space-y-5">
      <Tabs
        value={activeTab}
        onChange={(_, value) => onTabChange(value)}
        variant="scrollable"
        scrollButtons={false}
        allowScrollButtonsMobile
        className="md:hidden"
        sx={tabSx}
      >
        {TABS.map((tab) => (
          <Tab key={tab.key} label={tab.label} value={tab.key} />
        ))}
      </Tabs>

      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between md:gap-4">
        <div className="w-full md:w-[35%] md:min-w-[200px]">
          <MaInput
            fullWidth
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search products..."
            borderColor="#E5E7EB"
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <LuSearch className="text-[20px] text-[#9CA3AF]" />
                  </InputAdornment>
                ),
              },
            }}
          />
        </div>

        <div className="grid grid-cols-2 gap-3 md:flex md:flex-wrap md:items-center md:gap-3 md:shrink-0">
          <div className="hidden min-w-[140px] md:block md:flex-none">
            <MaInput
              select
              fullWidth
              value={statusMenu}
              onChange={(e) => onStatusMenuChange(e.target.value)}
              disabled={statusMenuDisabled}
              SelectProps={FILTER_SELECT_PROPS}
              sx={{ opacity: statusMenuDisabled ? 0.55 : 1 }}
              borderColor="#E5E7EB"
            >
              <MenuItem value="">Status</MenuItem>
              <MenuItem value="pending">Pending (created)</MenuItem>
              <MenuItem value="approved">Approved</MenuItem>
              <MenuItem value="rejected">Rejected</MenuItem>
              <MenuItem value="out-of-stock">Out of stock</MenuItem>
            </MaInput>
          </div>
          <div className="min-w-0 col-span-2 md:col-span-1 md:min-w-[160px] md:flex-none">
            <MaInput
              select
              fullWidth
              value={categoryMenu}
              onChange={(e) => onCategoryMenuChange(e.target.value)}
              SelectProps={FILTER_SELECT_PROPS}
              borderColor="#E5E7EB"
            >
              <MenuItem value="">Category</MenuItem>
              <MenuItem value="accessories">Accessories</MenuItem>
              <MenuItem value="fashion">Fashion</MenuItem>
              <MenuItem value="gadget">Gadget</MenuItem>
            </MaInput>
          </div>
        </div>
      </div>

      <Tabs
        value={activeTab}
        onChange={(_, value) => onTabChange(value)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        className="hidden md:block"
        sx={tabSx}
      >
        {TABS.map((tab) => (
          <Tab key={tab.key} label={tab.label} value={tab.key} />
        ))}
      </Tabs>
    </div>
  );
}
